export default "__VITE_ASSET__ac25d28a__"